<script>
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import wsc from "./PageSocket.js";
import $ from "jquery";
import backEndApi, { apiErrorEvent, setAccessToken, getAccessToken } from "@api/backEndApi.js";
// import LogTableStatus from "@src/views/sys/data-management/retention/LogTableStatus.vue";
const { isEmpty, readStorage } = global.xe;
const { encryptObj, decryptObj } = global.xe;
Vue.use(Vuex);

apiErrorEvent.addListener("Unauthorized", () => {
    console.log(`★★★ PageStore Unauthorized ★★★`);
    //store.state.accessToken = null;
    //store.actions.LOGOUT("");
    const loginUser = store.getters.loginUser;
    console.log(loginUser);
    if (isEmpty(loginUser)) return;

    store.dispatch("LOGOUT", loginUser);
});

const store = new Vuex.Store({
    state: {
        master: (decryptObj(localStorage.loginUser) ? decryptObj(localStorage.loginUser).master : {}) || {},
        masterGroup: {},
        accessToken: null,
        loginUser: decryptObj(localStorage.loginUser),
        loginGroups: decryptObj(localStorage.loginGroups),

        locale: "kr",
        nations: [],
        // localStorage.strings:{},

        isEditMode: false,
        isToolbar: false,
        isTransMode: false,
        isHelpMode: false,

        // navs: {}, // localStorage.menus  // TODO: 모바일 전환시 갱신되지 않음.
        currentMenu: {}, // 상단 대메뉴에서 클릭된 메뉴. currentNav : nav임
        mainMenu: {}, // 현재선택된 메뉴
        navMenus: [],

        // 백엔드 활성 플러그인 이름 목록 (서브모듈 가드용)
        activePluginNames: [],

        weather: {}, // 마스터 도시의 기상정보임.. 헤더상단표시..

        isWscConnected: false,
        //targetClient: "PC",

        alarmLogsRegDt: new Date().format("yyyyMMddHHmmss"), // 알람로그 최종업데이트 일자로 알람목록의 변경을 watch한다.
        // localStorage.alarmLogs: []

        serverNow: "",
        liveDate: "", // 서버 분 단위 시각. 화면에서 watch 를 걸어 변경(분 경과)을 감지하는 신호로 쓴다.
        // localStorage.liveReal: {},
        // localStorage.liveAM: {}, // ptAddr map object임
        // localStorage.liveIM: {},  // ptIdx map object임
        socketData: "",

        showErrorPoint: false,
        totalReal: null,
        /** 관제점 정보 맵(ptAddr → 메타). 과거 localStorage.liveAM 을 인메모리로 전환 */
        liveAM: {},
        ISsocket: false,
        tmpTotalArray: [],
        equipUpdateInfo: [],
        chartGridIdx: null,

        TotalTimeout: null,
        checkGetTotal: null,
        chartSelectValue: null,
        sessionLoginTimer: null,
        weatherInterval: null, // weather 주기 갱신 인터벌 핸들(앱 생애에 1개만 유지)

        receiveEquipCtrl: false,

        startTimer: { minutes: 10, seconds: 0 },
        autoLogoutTimer: 0,
        autoLogoutInterval: null,
        autoLogoutState: false,
        isAutoLogout: false,

        // CommonCode by badblock. 20240328
        commonCodes: {},
        unitCodes: {},

        // zoneInfo by woonsik. 20240419
        zoneInfo: null,
        unitTypes: null, // 삭제예정
        units: null, // 삭제 예정

        // TODO : to be removed
        scheduleDetails: null,
        scheduleDetail: null,

        // searchComponent TableViewSelect by woonsik, 240612
        pointListOptions: null,

        driverList: null,
        equipTypeList: null,
        systemTypeList: null,

        transSysType: null,
        transEquipType: null,

        // 관제점 관리 검색 옵션 저장
        // searchType: "device",
        // firstOption: null,
        // secondOption: null,
        // thirdOption: null,
        searchOptions: {
            pointInfo: {
                searchType: "point",
                firstOption: null,
                secondOption: null,
                thirdOption: null,
                clickedRowId: null,
                currentPage: null,
            },
        },

        // made by woonsik, wooksik 20240823
        pointList: null,
        // 최초로그인 시 Welcome 페이지를 렌더링하기 위함
        showWelcome: false,
        alarmLogList: [],
        updateAlarmBadge: false,
        selectedAlarmLogIdx: null,
        widgetStyle: {
            titleColor: "#eee", // 위젯 타이틀 배경색
            fontColor: "#424242", // 위젯 타이틀 폰트색
            backgroundImage: "", // 대시보드 배경 이미지
        },
        keepAlive: null,

        // 오래걸리는 작업의 경우 spinner 표시를 위한 변수
        isLoading: false,
    },
    getters: {
        getisAutoLogout(state) {
            return state.isAutoLogout;
        },
        getAutoLogoutState(state) {
            return state.autoLogoutState;
        },
        getReceiveEquipCtrl(state) {
            return state.receiveEquipCtrl;
        },

        getChartSelectValue(state) {
            return state.chartSelectValue;
        },
        getTotalReal(state) {
            return state.totalReal;
        },
        getLiveAM(state) {
            return state.liveAM;
        },
        wssUrl() {
            return wsc.wssUrl;
        },
        master(state) {
            return state.master;
        },
        masterGroup(state) {
            return state.masterGroup;
        },
        isAuthenticated(state) {
            state.accessToken = state.accessToken || localStorage.accessToken;
            return state.accessToken;
        },
        loginUser(state) {
            return state.loginUser;
        },
        loginGroups(state) {
            return state.loginGroups;
        },
        activePluginNames(state) {
            return state.activePluginNames || [];
        },
        locale(state) {
            return state.locale;
        },
        isEditMode(state) {
            return state.isEditMode;
        },
        isToolbar(state) {
            return state.isToolbar;
        },
        isTransMode(state) {
            return state.isTransMode;
        },
        isHelpMode(state) {
            return state.isHelpMode;
        },
        // navs(state) {
        //   return state.navs;
        // },
        currentMenu(state) {
            return state.currentMenu;
        },
        mainMenu(state) {
            return state.mainMenu;
        },
        weather(state) {
            return state.weather;
        },
        alarmLogsRegDt(state) {
            return state.alarmLogsRegDt;
        },
        alarmLogLists(state) {
            return state.alarmLogList;
        },
        isWscConnected(state) {
            return state.isWscConnected;
        },
        serverNow(state) {
            return state.serverNow;
        },
        liveDate(state) {
            return state.liveDate;
        },
        showErrorPoint(state) {
            return state.showErrorPoint;
        },
        getSessionTimer(state) {
            return state.sessionLoginTimer;
        },
        commonCodes(state) {
            return state.commonCodes;
        },
        zoneInfo(state) {
            return state.zoneInfo;
        },
        pointListOptions(state) {
            return state.pointListOptions;
        },
        unitTypes(state) {
            return state.unitTypes;
        },
        units(state) {
            return state.units;
        },
        systemTypeList(state) {
            return state.systemTypeList;
        },
        driverList(state) {
            return state.driverList;
        },
        equipTypeList(state) {
            return state.equipTypeList;
        },
        transSysType(state) {
            return state.transSysType;
        },
        transEquipType(state) {
            return state.transEquipType;
        },
        unitCodes(state) {
            return state.unitCodes;
        },
        GET_SCHEDULE_DETAILS(state) {
            return state.scheduleDetails;
        },
        SET_SCHEDULE_DETAIL(state) {
            return state.scheduleDetail;
        },
        searchOptions(state) {
            return state.searchOptions;
        },
        getShowWelcome(state) {
            return state.showWelcome;
        },
        getAlarmFlag(state) {
            return state.updateAlarmBadge;
        },
        getAlarmLogIdx(state) {
            return state.selectedAlarmLogIdx;
        },
        getNavMenus(state) {
            return state.navMenus;
        },
        getWidgetStyle(state) {
            return state.widgetStyle;
        },
        getIsLoading(state) {
            return state.isLoading;
        },
    },
    mutations: {
        SET_AUTO_LOGOUT_TRIGGER(state, value) {
            state.isAutoLogout = value;
        },
        SET_AUTO_LOGOUT_STATE(state, value) {
            state.autoLogoutState = value;
        },
        SET_RECEIVE_EQUIP_CTRL(state, value) {
            state.receiveEquipCtrl = value;
        },
        SET_SESSION_LOGIN_TIMER(state, value) {
            state.sessionLoginTimer = value;
        },
        SET_CHART_SELECT_VALUE(state, value) {
            state.chartSelectValue = value;
        },
        UPDATE_ALARM_BADGE(state, value) {
            state.updateAlarmBadge = value;
        },
        EQUIP_INFO_INSERT(state, ptAddr) {
            if (state.equipUpdateInfo.includes(ptAddr) === false) {
                state.equipUpdateInfo.push(ptAddr);
            }
        },
        EQUIP_INFO_DELETE(state, ptAddr) {
            let idx = state.equipUpdateInfo.findIndex((el) => el === ptAddr);

            if (idx !== -1) {
                state.equipUpdateInfo.splice(idx, 1);
            }
        },

        // mutations: this.$store.commit("UPDATE_EDIT_MODE", param)
        // action: this.$store.dispatch("LOGIN", param)
        UPDATE_MASTER(state, master) {
            if (state.loginUser) {
                if (state.loginUser.masterCode === master.masterCode) {
                    state.master = master;
                } else {
                    console.log("로그인사용자와 다른 마스터 정보를 할당할 수 없습니다.");
                }
            } else {
                state.master = master;
            }

            // HEMS는 Header/WeatherTop 미사용 — 날씨 API·주기 갱신 스킵 (PC는 기존 유지)
            if (global.xe.isHemsRoute()) {
                if (state.weatherInterval) {
                    clearInterval(state.weatherInterval);
                    state.weatherInterval = null;
                }
                return;
            }

            this.dispatch("UPDATE_WEATHER");

            // weather 주기 갱신 인터벌은 1개만 유지한다. 재로그인·마스터전환으로 이 mutation 이
            // 여러 번 커밋돼도 인터벌이 누적(호출 N배·타이머 누수)되지 않도록 기존 것을 먼저 정리한다.
            if (state.weatherInterval) clearInterval(state.weatherInterval);
            state.weatherInterval = setInterval(
                () => {
                    this.dispatch("UPDATE_WEATHER");
                },
                60 * 60 * 1000,
            );
        },
        UPDATE_MASTER_GROUP(state, masterGroup) {
            state.masterGroup = JSON.parse(JSON.stringify(masterGroup));
        },
        UPDATE_ACCESS_TOKEN(state, accessToken) {
            state.accessToken = accessToken;
        },
        LOGIN(state, { master, accessToken, user, groups, menus, strings, systemInfo }) {
            axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

            // TODO: 로그인시 저장되는 것들 암호화해서 localStorage에 넣어야 함.  키값도 알 수 없게 해야 함.
            // UPDATE_LOGIN,  UPDATE_LOGIN_INFO

            state.master = master;
            //user.master = master; // TODO: 임시..  서버에서도 user.master에 이미 데이터를 넣어 주고 있음. 어디서 사용하는지 찾아서 프로세스 바꿔야 함.

            state.loginUser = user;
            state.loginGroups = groups;
            state.accessToken = accessToken;

            this.commit("UPDATE_LOGIN_INFO", {
                accessToken,
                user,
                groups,
                menus,
                strings,
                systemInfo,
            });

            // HEMS는 실시간 관제점 WS 불필요 (PC만 연결)
            if (!global.xe.isHemsRoute()) {
                wsc.createWsc(this);
            }
        },
        // eslint-disable-next-line no-unused-vars
        UPDATE_LOGIN_INFO(state, { accessToken, user, groups, menus, strings, systemInfo, unitConversionVersion }) {
            // master: master,
            // user: login.user,
            // groups: login.groups,
            // menus: menus,
            // accessToken: accessToken,
            // strings: strings,
            // systemInfo: systemInfo
            // unitConversionVersion: unitConversionVersion (환산계수 버전)
            localStorage.accessToken = accessToken;
            localStorage.loginUser = encryptObj(user);
            localStorage.loginGroups = encryptObj(groups);
            localStorage.systemInfo = JSON.stringify(systemInfo);

            state.loginUser = user;
            //this.commit("UPDATE_STRINGS", { strings });

            /** 번역 문구 임시 변환 */
            let stringKeys = Object.keys(strings);
            let newStrings = [];
            for (let i = 0; i < stringKeys.length; i++) {
                newStrings.push({
                    key: stringKeys[i],
                    ...strings[stringKeys[i]],
                });
            }

            let newObjectStrings = newStrings.reduce(
                (obj, item) => ((obj[item.key] = { [state.locale]: item[state.locale] }), obj),
                {},
            );

            localStorage.strings = JSON.stringify(newObjectStrings);

            this.commit("UPDATE_MENUS", menus);
        },
        LOGOUT(state) {
            axios.defaults.headers.common["Authorization"] = undefined;

            wsc.destroyWsc();

            // weather 주기 갱신 정지(로그아웃 후 불필요한 인터벌·API 호출 제거)
            if (state.weatherInterval) {
                clearInterval(state.weatherInterval);
                state.weatherInterval = null;
            }

            state.loginUser = {};
            state.loginGroups = {};
            state.accessToken = null;
            state.activePluginNames = [];
            state.liveAM = {};
            delete localStorage.loginUser;
            delete localStorage.loginGroups;
            delete localStorage.accessToken;
            // 더 이상 쓰지 않는 실시간 캐시 정리(인메모리 totalReal 단일 소스로 전환)
            delete localStorage.liveReal;
            delete localStorage.liveAM;
            delete localStorage.liveIM;
        },
        SET_ACTIVE_PLUGIN_NAMES(state, names) {
            state.activePluginNames = Array.isArray(names) ? names : [];
        },
        // UPDATE_TARGET_CLIENT(state, targetClient) {
        //   state.targetClient = targetClient;
        // },
        UPDATE_LOCALE(state, locale) {
            try {
                if (isEmpty(locale)) {
                    console.error(`UPDATE_LOCALE mutations locale error = ${locale}`);
                    return;
                }

                global.xe.locale = locale;
                state.locale = locale;

                // 달력컨트롤 한글화 -// TODO: 바로 적용되지 않음.
                let datepickerlocale = { en: "en", kr: "ko" };
                $.extend(true, $.fn.datetimepicker.defaults, {
                    locale: datepickerlocale[state.locale] ? datepickerlocale[state.locale] : state.locale,
                });

                this.dispatch("UPDATE_MENUS");
                // Validation 메세지 다국어
                // Validator.configure(locale);
            } catch (err) {
                console.error("UPDATE_LOCALE mutations", err);
            }
        },
        UPDATE_EDIT_MODE(state, isEditMode) {
            state.isEditMode = isEditMode;
        },
        UPDATE_TOOLBAR(state, isToolbar) {
            state.isToolbar = isToolbar;
        },
        UPDATE_TRANS_MODE(state, isTransMode) {
            state.isTransMode = isTransMode;
        },
        UPDATE_HELP_MODE(state, isHelpMode) {
            state.isHelpMode = isHelpMode;
        },
        UPDATE_MENUS(state, menus) {
            try {
                localStorage.menus = JSON.stringify(menus);
                //state.navs = Vue.convertNavList(menus); // 화면 navigation용 개체로 변환한다.
                //localStorage.navs = JSON.stringify(Vue.convertNavList(menus));
            } catch (err) {
                console.log("UPDATE_MENUS mutation error", err);
            }
        },
        UPDATE_CURRENT_MENUS(state, menu) {
            state.currentMenu = menu; // menu는 nav개체임..  상단 navigation에서 선택된 nav를 현재 nav로 지정한다.
        },
        UPDATE_MAIN_MENUS(state, menu) {
            state.mainMenu = menu;
        },
        UPDATE_WEATHER(state, weathers) {
            if (weathers && Array.isArray(weathers)) {
                let now = new Date().format("yyyyMMddHH") + "00"; // forecastDt는 DB상에 "201906010000" 분까지 들어있음..
                weathers.forEach((weather) => {
                    // 현재시간에 해당하는 예보를 찾아서 보여줌..
                    if (weather.forecastDt < now) {
                        // now에 가장 가까운데이터가 마지막으로 들어감..
                        state.weather = weather;
                    }
                });
            }
        },
        UPDATE_IS_WSC_CONNECTED(state, isWscConnected) {
            state.isWscConnected = isWscConnected;
        },
        UPDATE_ALARM_LOGS(state, msg) {
            if (isEmpty(state.accessToken)) return;

            let alarms = [];
            msg.alarmLogs
                .sort((a, b) => b.regDt - a.regDt) // ASC
                .forEach((v) => {
                    alarms.push(v);
                });

            state.alarmLogsRegDt = new Date().format("yyyyMMddHHmmss");
            localStorage.alarmLogs = JSON.stringify(alarms);
        },
        UPDATE_ALARM_LOGS2(state, msg) {
            if (isEmpty(state.accessToken)) return;

            let alarms = [];
            msg.alarmLogs.forEach((v) => {
                alarms.push(v);
            });

            state.alarmLogList = alarms;
        },
        UPDATE_KEEP_ALIVE(state, msg) {
            // state.keepAlive = msg;
            let keepAlives = [];
            msg.keepAlive.forEach((v) => {
                keepAlives.push(v);
            });
            state.keepAlive = keepAlives;
        },
        /**
         * 서버 시계(serverNow) 동기화.
         *
         * 서버는 여전히 UPDATE_LIVE_REAL 메시지를 보내지만, 실시간 값은 totalReal 단일 소스로
         * 통합했으므로 값맵(msg.liveReal)은 쓰지 않고 시각(msg.now)만 사용한다.
         * (live-stack 시계열 누적은 xeLiveTable 컴포넌트가 자체 타이머로 담당한다)
         */
        SYNC_SERVER_CLOCK(state, msg) {
            try {
                state.serverNow = msg.now.parseDate(); // 서버시계 동기화
                state.liveDate = msg.now.format("yyyyMMddHHmmss");
            } catch (err) {
                console.error("SYNC_SERVER_CLOCK mutations", err);
            }
        },
        UPDATE_EQUIP_CTRL(state, msg) {
            state.receiveEquipCtrl = true;
            try {
                let contrlPoint = msg.contrlPoint;

                for (let i = 0; i < contrlPoint.length; i++) {
                    let idx = state.equipUpdateInfo.findIndex((el) => el === contrlPoint[i]);

                    if (idx !== -1) {
                        state.equipUpdateInfo.splice(idx, 1);
                    }
                }
            } catch (error) {
                console.error("UPDATE_EQUIP_CTRL ERROR ::: ", error);
            }
        },
        /**
         * 웹소켓으로 들어온 실시간 델타(변경된 관제점만)를 인메모리 totalReal 맵에 병합한다.
         *
         * 과거에는 localStorage 를 병합 base 로 삼아, 지난 세션의 묵은 값이 매 프레임 재주입되고
         * 갱신되지 않는 관제점이 영구히 낡은 값으로 남는 문제가 있었다. 이제 base 는 state.totalReal
         * 하나뿐이며, 끊긴 동안의 공백은 (재)연결 시 SEED_TOTAL_REAL 이 전체 스냅샷으로 따로 메운다.
         */
        UPDATE_TOTAL_REAL(state, msg) {
            try {
                if (isEmpty(state.accessToken) || isEmpty(msg.totalReal)) return;

                const totalReal = { ...(state.totalReal || {}) };
                for (const point of msg.totalReal) {
                    if (point?.ptAddr != null) totalReal[point.ptAddr] = point;
                }
                state.totalReal = totalReal;
            } catch (err) {
                console.error("UPDATE_TOTAL_REAL mutations", err);
            }
        },
        /**
         * (재)연결 시 searchTotalRealList 전체 스냅샷으로 totalReal 을 보정한다.
         *
         * 웹소켓은 변경분(델타)만 보내므로, 연결이 끊긴 동안 바뀐 값이나 한 번도 보고되지 않은
         * 관제점은 델타만으로는 따라잡지 못한다. 전체 스냅샷으로 그 공백을 한 번에 메운다.
         *
         * 스냅샷 조회(HTTP)가 도는 사이 더 최신 델타가 먼저 도착할 수 있으므로, 보유 중인 값이
         * 같거나 더 최신(regDt 비교)이면 덮지 않는다 — 스냅샷이 최신 델타를 과거로 되돌리지 않도록.
         * @param {Array} snapshot - searchTotalRealList 응답(tb_total_real 전체 행 배열)
         */
        SEED_TOTAL_REAL(state, snapshot) {
            if (!Array.isArray(snapshot)) return;

            const totalReal = { ...(state.totalReal || {}) };
            for (const point of snapshot) {
                if (point?.ptAddr == null) continue;

                const current = totalReal[point.ptAddr];
                const hasFresherDelta = current && String(current.regDt) >= String(point.regDt);
                if (hasFresherDelta) continue;

                totalReal[point.ptAddr] = point;
            }
            state.totalReal = totalReal;

            // 이전 버전이 totalReal 을 보관하던 캐시는 더 이상 쓰지 않으므로 정리한다.
            try {
                delete localStorage.totalReal;
            } catch (err) {
                console.warn("localStorage.totalReal 정리 실패", err);
            }
        },
        /**
         * 관제점 정보 맵(liveAM) 전체를 교체한다. action(UPDATE_PT_MAP)이 searchPointAM 으로 받아온 맵을 넘긴다.
         *
         * 과거에는 localStorage 에 보관(+ 미사용 liveIM 파생)했으나, 인메모리로 전환했다. liveAM 은
         * 통째로 교체/병합되는 읽기 전용 메타라, Object.freeze 로 Vue 의 반응성 변환 비용을 피한다
         * (참조 자체를 교체하므로 getter 로 읽는 소비처의 반응성은 유지된다).
         */
        SET_LIVE_AM(state, liveAM) {
            state.liveAM = Object.freeze(liveAM || {});
        },
        /**
         * 관제점 변경분(ptList 델타)을 liveAM 에 병합한다. base 는 인메모리 state.liveAM 이다.
         */
        UPDATE_PT_LIST(state, msg) {
            try {
                state.liveAM = Object.freeze({ ...state.liveAM, ...msg.ptList });
            } catch (err) {
                console.error("UPDATE_PT_LIST mutations", err);
            }
        },
        // UPDATE_STRINGS(state, { strings }) {
        //   localStorage.strings = JSON.stringify(strings);
        // },
        UPDATE_TRANS(state, { strings }) {
            // 메뉴 다국어가 도착하면, 다국어문자열에 합친다.
            let localStrings = Object.assign(readStorage("strings"), strings);
            localStorage.strings = JSON.stringify(localStrings);
        },

        RUN_AUTO_LOGOUT_TIMER(state) {
            if (state.autoLogoutState === false) return;

            // let time;
            state.autoLogoutTimer -= 1000;

            if (state.autoLogoutTimer < 1000) {
                this.dispatch("LOGOUT", state.loginUser);
                clearInterval(state.autoLogoutInterval);
                this.commit("SET_AUTO_LOGOUT_TRIGGER", true);
                // element.innerHTML = "Time is up!";
            }
        },
        UPDATE_NATIONS(state, value) {
            state.nations = value;
        },
        SET_COMMON_CODES(state, commonCodes) {
            state.commonCodes = commonCodes;
        },
        SET_ZONE_INFO(state, zoneInfo) {
            state.zoneInfo = zoneInfo;
        },
        SET_POINTVIEW_OPTIONS(state, pointListOptions) {
            state.pointListOptions = pointListOptions;
        },
        SET_UNIT_TYPES(state, unitTypes) {
            state.unitTypes = unitTypes;
        },
        SET_UNITS(state, units) {
            state.units = units;
        },
        SET_SYSTEM_TYPE_LIST(state, systemTypeList) {
            state.systemTypeList = systemTypeList;
        },
        SET_DRIVER_LIST(state, driverList) {
            state.driverList = driverList;
        },
        SET_EQUIP_TYPE_LIST(state, equipTypeList) {
            state.equipTypeList = equipTypeList;
        },
        SET_TRANS_SYSTEM_TYPE(state, transSysType) {
            state.transSysType = transSysType;
        },
        SET_TRANS_EQUIP_TYPE(state, transEquipType) {
            state.transEquipType = transEquipType;
        },
        SET_UNIT_CODES(state, unitCodes) {
            state.unitCodes = unitCodes;
        },
        SET_SCHEDULE_DETAILS(state, payload) {
            state.scheduleDetails = payload;
        },
        // ADD_SCHEDULE_DETAIL(state, newDetail) {
        // 	state.scheduleDetails.push(newDetail)
        // },
        ADD_SCHEDULE_DETAIL(state, payload) {
            state.scheduleDetails = null;
            state.scheduleDetails = payload;
        },
        DELETE_SCHEDULE_DETAIL(state, detailId) {
            state.scheduleDetails = state.scheduleDetails.filter((detail) => detail.id !== detailId);
        },
        SET_SCHEDULE_DETAIL(state, payload) {
            state.scheduleDetail = payload;
        },
        SET_SEARCH_OPTIONS(state, searchOptions) {
            state.searchOptions.pointInfo = {
                ...state.searchOptions.pointInfo,
                ...searchOptions,
            };
        },
        // made by woonsik, wooksik 20240823
        SET_POINT_LIST(state, pointList) {
            state.pointList = pointList;
        },
        SET_SHOW_WELCOME(state, value) {
            state.showWelcome = value;
        },
        SET_ALARMLOGIDX(state, value) {
            state.selectedAlarmLogIdx = value;
        },
        SET_NAVMENUS(state, value) {
            state.navMenus = value;
        },
        SET_WIDGET_STYLE(state, style) {
            state.widgetStyle = { ...state.widgetStyle, ...style };
        },
        SET_IS_LOADING(state, value) {
            state.isLoading = value;
        },
    },
    actions: {
        // 자동 로그아웃 10분
        UPDATE_AUTO_LOGOUT_INTERVAL({ commit, state }) {
            let minutes = state.startTimer.minutes;
            let seconds = state.startTimer.seconds;

            // 임시로 Auto Logout 해제 by badblock.2024.04.23
            // 임시 해제 by woonsik 2025.02.25 (tag. Auto Logout)
            // 임시 해제 해제 by seongu 2025.06.05 (tag. Auto Logout)
            state.autoLogoutTimer = 1000 * (60 * minutes + seconds);

            // state.autoLogoutTimer = 5000;
            // state.autoLogoutTimer = 1000 * (60 * minutes + seconds) * 60 * 24 * 100;

            state.autoLogoutInterval = setInterval(() => {
                commit("RUN_AUTO_LOGOUT_TIMER");
            }, 1000);
        },
        UPDATE_AUTO_LOGOUT_STATE({ dispatch, commit, state }, value) {
            if (state.autoLogoutState === value) return;

            commit("SET_AUTO_LOGOUT_STATE", value);

            if (state.autoLogoutState === false) {
                clearInterval(state.autoLogoutInterval);
            } else {
                dispatch("UPDATE_AUTO_LOGOUT_INTERVAL");
            }
        },
        //페이지 새로고침시 헤더에 accessToken 토큰 설정
        UPDATE_TOKEN({ commit }) {
            const accessToken = getAccessToken();
            //backEndApi 헤더 토큰이 비어 있으면 로컬 스토리지에 있는 accessToken을 설정
            if (!isEmpty(accessToken)) return;

            setAccessToken(localStorage.accessToken);
            commit("UPDATE_ACCESS_TOKEN", localStorage.accessToken);
        },
        CREATE_WEB_SOCKET() {
            if (global.xe.isHemsRoute()) return;
            wsc.createWsc(this);
        },
        UPDATE_MASTER({ commit }, selectMaster) {
            if (selectMaster) {
                commit("UPDATE_MASTER", selectMaster);
            } else {
                // if (isEmpty(axios.defaults.headers.common["Authorization"]))
                //   return;

                backEndApi.master
                    .getMaster()
                    .then(({ data }) => {
                        commit("UPDATE_MASTER", data);
                    })
                    .catch((err) => {
                        console.log(`★★★ UPDATE_MASTER Error => ${err} ★★★`);
                    });
            }
        },
        UPDATE_MASTER_GROUP({ commit }) {
            backEndApi.login.getMasterGroup().then(({ data }) => {
                commit("UPDATE_MASTER_GROUP", data);
            });
        },
        LOGIN({ commit }, { masterCode, userId, password, targetClient }) {
            return new Promise(async (resolve, reject) => {
                // password = await hash(password);

                let client = targetClient || global.xe.getTargetClient();

                backEndApi.login
                    .signin({ masterCode, userId, password, targetClient: client })
                    .then(({ data }) => {
                        console.log("Login response:", data);
                        console.log("Response type:", typeof data);
                        console.log("Data keys:", Object.keys(data));
                        console.log("errno value:", data.errno, "type:", typeof data.errno);
                        console.log("accessToken:", data.accessToken);

                        // 서버 응답 구조에 따라 성공/실패 판단
                        // 서버 응답 구조에 따라 성공/실패 판단
                        // accessToken이 있으면 성공으로 처리
                        if (data.accessToken && data.accessToken.length > 0) {
                            console.log("Login success - committing to store");
                            commit("LOGIN", data);
                            resolve();
                        } else {
                            console.log("Login failed - rejecting");
                            reject(data);
                        }
                    })
                    .catch((data) => {
                        console.error("Login error:", data);
                        reject(data);
                    });
            });
        },
        LOGOUT({ commit }, { userId }) {
            commit("LOGOUT");
            import("@src/utils/mobileBridge.js").then((m) => m.default.clearSavedAccessToken());

            backEndApi.login.signout(userId).catch((err) => {
                console.debug("로그아웃 실패", err);
            });
        },
        UPDATE_LOGIN_INFO({ getters, commit }) {
            if (!getters.isAuthenticated) return;
            if (!getters.loginUser.userId) return;

            let targetClient = global.xe.getTargetClient();

            backEndApi.user.getLoginInfo(getters.loginUser.userId, targetClient).then(({ data }) => {
                // console.debug("UPDATE_LOGIN_INFO actions=", data);

                commit("UPDATE_LOGIN_INFO", data);

                // 환산계수 동기화 서비스 초기화
                if (data && data.unitConversionVersion) {
                    // 동적 import로 서비스 로드 (순환 참조 방지)
                    import("@libs/unitConversionService.js")
                        .then((module) => {
                            const unitConversionService = module.default;
                            unitConversionService.initialize(data.unitConversionVersion);
                        })
                        .catch((err) => {
                            console.error("환산계수 서비스 초기화 실패:", err);
                        });
                } else {
                    console.warn("[PageStore] unitConversionVersion이 없습니다. data:", data);
                }
            });
        },
        UPDATE_MENUS({ getters, commit }) {
            if (!getters.isAuthenticated) return;
            if (!getters.loginUser.userId) return;

            let targetClient = global.xe.getTargetClient();

            backEndApi.menu.searchMenuLoginUser(getters.loginUser.userId, targetClient).then(({ data }) => {
                //console.debug("UPDATE_MENUS actions", data);
                commit("UPDATE_MENUS", data);
            });
        },
        UPDATE_WEATHER({ getters, commit }) {
            if (!getters.isAuthenticated) return;
            if (global.xe.isHemsRoute()) return;

            let { countryCode, cityCode } = getters.master;

            let sDt = new Date().format("yyyyMMdd0000");
            let eDt = new Date().format("yyyyMMdd2359");
            backEndApi.weather.searchWeatherByPeriod(countryCode, cityCode, sDt, eDt).then(({ data }) => {
                commit("UPDATE_WEATHER", data);
            });
        },
        UPDATE_PT_MAP({ getters, commit }) {
            if (!getters.isAuthenticated) return;

            //backEndApi.pointInfo.searchPointAM().then(({ data }) => {
            backEndApi.pointInfo.searchPointAM().then(({ data }) => {
                if (!isEmpty(data)) {
                    commit("SET_LIVE_AM", data);
                } else {
                    console.log("UPDATE_PT_MAP actions data is abnormal. ", data);
                }
            });
        },
        // UPDATE_STRINGS({ getters, commit }) {
        //   if (!getters.isAuthenticated) return;

        //   backEndApi.engineering.searchStrings().then(({ data }) => {
        //     commit("UPDATE_STRINGS", data);
        //   });
        // },
        UPDATE_TRANS({ getters, commit }) {
            if (!getters.isAuthenticated) return;

            backEndApi.login.searchTrans().then(({ data }) => {
                commit("UPDATE_TRANS", data);
            });
        },

        async FETCH_COMMON_CODES({ commit }) {
            const commonCodes = {};

            try {
                // Fetch Common Code
                // getCommonCodeList2 API : etcInfo가 정의되어 있으면 options 프로퍼티에 저장r
                let result = await backEndApi.commonCode.getCommonCodesForService("Y");
                if (result && result.data) {
                    // Make commonCode Object
                    // 	- ex) commonCodes.energySourceCode : [Elec,Gas,....]

                    // 받는 데이터의 규격이 달라짐에따라 수정함 author.선구
                    // 현재
                    // result.data.forEach((code) => {
                    //     let items = code.codeItems.map((item) => {
                    //         return { value: item.codeItem, text: item.codeName, options: item.options };
                    //     });
                    // 수정
                    result.data.forEach((code) => {
                        let items = code.codeItems.map((item) => {
                            let otherKeys = Object.keys(item).filter((key) => key !== "codeItem" && key !== "codeName");

                            let optionsValue = otherKeys.reduce((acc, key) => {
                                acc[key] = item[key];
                                return acc;
                            }, {});

                            return {
                                value: item.codeItem,
                                text: item.codeName,
                                options: optionsValue,
                            };
                        });

                        commonCodes[code.commonCode] = items;
                    });
                }

                commit("SET_COMMON_CODES", JSON.parse(JSON.stringify(commonCodes)));
            } catch (error) {
                console.error("Error fetching common codes: ", error);
            }
        },
        async FETCH_UNIT_CODES({ commit }) {
            const unitCodes = {};
            let units = {};
            let unitTypes = null;

            try {
                // Fetch Unit Code
                let result = await backEndApi.newUnitCode.getUnitCodeList();
                if (result && result.data) {
                    result.data.forEach((unit) => {
                        let items = unit.codeItems.map((item) => {
                            return { value: item.codeItem, text: item.codeName };
                        });

                        unitCodes[unit.unitCode] = items;
                    });

                    unitTypes = result.data.map((unit) => {
                        return { value: unit.unitCode, text: unit.codeName };
                    });

                    units = result.data
                        .reduce((acc, item) => {
                            acc.push(...item.codeItems);
                            return acc;
                        }, [])
                        .map((unit) => ({
                            value: unit.codeItem,
                            text: unit.codeName,
                        }));
                }

                commit("SET_UNIT_CODES", JSON.parse(JSON.stringify(unitCodes)));
                commit("SET_UNIT_TYPES", JSON.parse(JSON.stringify(unitTypes)));
                commit("SET_UNITS", JSON.parse(JSON.stringify(units)));
            } catch (error) {
                console.error("Error fetching common codes: ", error);
            }
        },

        async FETCH_ZONE_INFO({ commit }) {
            let zoneInfo = null;

            try {
                let result = await backEndApi.zoneInfo.getZoneInfoList();
                if (result && result.data) {
                    let items = result.data.map((zone) => {
                        return { value: zone.zoneIdx, text: zone.zoneName };
                    });
                    zoneInfo = items;
                }
                commit("SET_ZONE_INFO", zoneInfo);
            } catch (error) {
                console.error("Error fetching common codes: ", error);
            }
        },

        FETCH_POINTLIST_OPTIONS({ commit, state }) {
            try {
                let pointInfoField = state.commonCodes.pointInfoField.map((item) => {
                    return {
                        key: item.value,
                        text: item.text,
                        checked: item.options.defaultYn == "Y" ? true : false,
                    };
                });
                commit("SET_POINTVIEW_OPTIONS", pointInfoField);
            } catch (e) {
                console.error(e);
            }
        },

        async FETCH_SYSTEM_TYPE_LIST({ commit }) {
            let trans = [];
            try {
                let result = await backEndApi.sysType.getSysTypeList("Y");
                if (result.status == 200) {
                    result.data.forEach((type) => {
                        trans.push({
                            value: type.sysType,
                            text: type.sysTypeName,
                        });
                    });
                    commit("SET_SYSTEM_TYPE_LIST", result.data);
                    commit("SET_TRANS_SYSTEM_TYPE", trans);
                }
            } catch (e) {
                console.error(e);
            }
        },

        // 반복적인 로딩과 컴포넌트 독립성을 높이기 위해 Store 처리함 (2024.07.21)
        async FETCH_DRIVER_LIST({ commit }) {
            try {
                let result = await backEndApi.driver.searchDriver();
                if (result.status == 200) {
                    commit("SET_DRIVER_LIST", result.data);
                }
            } catch (e) {
                console.error(e);
            }
        },

        async FETCH_EQUIP_TYPE_LIST({ commit }) {
            let trans = [];
            try {
                let result = await backEndApi.equipTypes.getEquipTypeList("Y");
                if (result.status == 200) {
                    result.data.forEach((type) => {
                        trans.push({
                            value: type.equipType,
                            text: type.equipTypeName,
                        });
                    });
                    commit("SET_EQUIP_TYPE_LIST", result.data);
                    commit("SET_TRANS_EQUIP_TYPE", trans);
                }
            } catch (e) {
                console.error(e);
            }
        },

        async FETCH_SCHEDULE_DETAILS({ commit }) {
            try {
                let result = await backEndApi.equipControl.getSchdCtrlList();
                commit("SET_SCHEDULE_DETAILS", result.data);
            } catch (error) {
                console.error("Error fetching schedule details:", error);
            }
        },
        async FETCH_SCHEDULE_DETAIL({ commit }, index) {
            try {
                let result = await backEndApi.equipControl.getEquipCtrlSchDetail(index);
                commit("SET_SCHEDULE_DETAIL", result.data);
            } catch (error) {
                console.error("Error fetching schedule detail:", error);
            }
        },
        /**
         * (재)연결 시 totalReal 전체 스냅샷을 받아 보정한다(ws open 콜백에서 호출).
         *
         * 서버는 연결 후 변경분(델타)만 보내고 전체 스냅샷은 보내지 않으므로(onConnect 는 liveReal
         * 만 전송), 끊긴 동안 생긴 totalReal 의 공백을 이 HTTP 스냅샷으로 메운다.
         */
        async FETCH_TOTAL_REAL_SEED({ commit, state }) {
            if (isEmpty(state.accessToken)) return;
            try {
                const searchTotalRealList_response = await backEndApi.pointInfo.searchTotalRealList();
                const searchTotalRealList_data = searchTotalRealList_response?.data;
                if (searchTotalRealList_response?.status === 200 && Array.isArray(searchTotalRealList_data)) {
                    commit("SEED_TOTAL_REAL", searchTotalRealList_data);
                }
            } catch (error) {
                console.error("Error seeding totalReal:", error);
            }
        },
        // made by woonsik, wooksik 20240823
        async FETCH_POINT_LIST({ commit }) {
            try {
                let result = await backEndApi.pointInfo.getPointList();
                if (result.status == 200) commit("SET_POINT_LIST", result.data);
            } catch (error) {
                console.error("Error fetching point list:", error);
            }
        },
        async FETCH_ACTIVE_PLUGINS({ commit, getters }) {
            if (!getters.isAuthenticated) return;
            try {
                const res = await backEndApi.pluginManage.getPlugins();
                const body = res?.data;
                if (res?.status !== 200 || body?.success === false) return;
                const plugins = body?.data?.plugins;
                const names = Array.isArray(plugins)
                    ? plugins.filter((p) => p.status === "active").map((p) => p.name)
                    : [];
                commit("SET_ACTIVE_PLUGIN_NAMES", names);
            } catch (e) {
                console.error("FETCH_ACTIVE_PLUGINS", e);
            }
        },
        UPDATE_ALARM_BADGE({ commit }, flag) {
            commit("UPDATE_ALARM_BADGE", flag);
        },
        UPDATE_ALARMLOGIDX({ commit }, idx) {
            commit("SET_ALARMLOGIDX", idx);
        },
    },
});

export default store;
</script>
